import cartSlice from "./reducers/cartSlice";
import orderSlice from "./reducers/orderSlice";
import { configureStore } from "@reduxjs/toolkit";
import appCommonSlice from "./reducers/appCommonSlice";
import layoutSlice from "./reducers/layoutSlice";
import drawerSlice from "./reducers/drawerSlice";
import manageDataSlice from "./reducers/manageDataSlice";
import mapSlice from "./../components/VMRS/MapAdapter/store/slices/mapSlice";
import aoiSlice from "./../components/VMRS/MapAdapter/store/slices/aoiSlice";
import drawSlice from "./../components/VMRS/MapAdapter/store/slices/drawSlice";
import measureSlice from "./../components/VMRS/MapAdapter/store/slices/measureSlice";
import layerSlice from "./../components/VMRS/MapAdapter/store/slices/layerSlice";
import notificationSlice from "./reducers/notificationSlice";
import mapTaskingSlice from "./reducers/mapTaskingSlice";
import statusAction from "./reducers/statusAction";
import searchSlice from "./reducers/searchSlice";
import timeLineSlice from "./reducers/timeLineSlice";
import feedbackSlice from "./reducers/feedbackSlice";
import historySlice from "./reducers/historySlice";
import dashboardSlice from "./reducers/dashboardSlice";
import downloadSlice from "./reducers/downloadSlice";

export const store = configureStore({
  reducer: {
    appCommonSlice: appCommonSlice,
    layoutSlice: layoutSlice,
    drawerSlice: drawerSlice,
    orderSlice: orderSlice,
    manageDataSlice: manageDataSlice,
    map: mapSlice,
    cartSlice: cartSlice,
    notificationSlice: notificationSlice,
    mapTasking: mapTaskingSlice,
    statusAction: statusAction,
    search: searchSlice,
    timeLine: timeLineSlice,
    feedbackSlice: feedbackSlice,
    historySlice: historySlice,
    dashboardSlice: dashboardSlice,
    aoi: aoiSlice,
    draw: drawSlice,
    measure: measureSlice,
    layer: layerSlice,
    download: downloadSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
